import * as React from "react";

import {Icon as IconLiterals} from "@client/constants";

import {BarItem} from "@client/components/BarItem";
import {TouchHandler} from "@client/components/TouchHandler";
import {Locator} from "@client/gotterdammerung";

interface SwitchProps {
    type: "switch";
    onClick: () => void;
    isEnabled: boolean;
    title: string;
    icon: IconLiterals;
}

interface ActionProps {
    type: "action";
    disabled?: boolean;
    onClick?: () => void;
    link?: string | Locator;
    title: string;
    icon: IconLiterals;
    highlight?: boolean;
}

export type Props = SwitchProps | ActionProps;

export const Action = (props: Props) => (
    <li style={{flex: 1}}>
        {"disabled" in props && props.disabled == true ? (
            <div className="opacity-50">
                <BarItem item={props} />
            </div>
        ) : (
            <TouchHandler
                link={"link" in props ? props.link : undefined}
                onClick={props.onClick}
            >
                <BarItem item={props} />
            </TouchHandler>
        )}
    </li>
);
